import { baseURL } from './request';

/**
 * 获取资源完整 URL
 * @param {string} url 相对路径或完整URL
 * @param {string} [storage] 存储类型 'local' | 'alioss'，不传则根据当前配置模式判断
 * @returns {string}
 */
export function getImageUrl(url, storage) {
    if (!url) return '';
    if (/^(https?:\/\/|\/\/|data:|blob:)/i.test(url)) return url;

    // 前端静态资源直接返回相对路径
    if (url.startsWith('/pcImgs/') || url.startsWith('/shopImgs/')) {
        return url;
    }

    const ossCdnUrl = localStorage.getItem('cdn_url');
    const serverUrl = localStorage.getItem('server_url');
    const mode = storage || localStorage.getItem('upload_mode') || 'local';

    let domain = '';
    if (mode === 'alioss' && ossCdnUrl) {
        // OSS 存储：使用 OSS CDN 域名
        domain = ossCdnUrl;
    } else {
        // 本地存储：使用服务器域名
        domain = serverUrl || baseURL || '';
    }

    return domain + url;
}
